import React, { useEffect, useState } from 'react'
import axios from '../services/axios'

export default function MessagesList() {
  const [items, setItems] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')
  const [editing, setEditing] = useState({})

  const handleDeepL = (row) => {
    const origine = row.message_origine || ''
    const edited = editing[row.id] !== undefined ? editing[row.id] : (row.message || '')
    const text = `${origine}\n${edited}`
    const encoded = encodeURIComponent(text)
    const url = `https://www.deepl.com/translator?share=generic#en/fr/${encoded}`
    window.open(url, '_blank', 'noopener')
  }

  const handleYaago = (row) => {
    window.open(row.lienyaago, '_blank', 'noopener')
  }


  const handleValidate = async (id) => {
    const newMessage = editing[id] !== undefined ? editing[id] : (items.find(i => i.id === id)?.message || '')
    await axios.put(`/api/messages/${id}`, { message: newMessage, status: 0 })
    setItems(prev => prev.map(item => item.id === id ? { ...item, message: newMessage } : item))
    setSuccess('Le message a bien été sauvegardé')
    setTimeout(() => setSuccess(''), 3000)
  }

  const handleSend = async (id) => {
    const newMessage = editing[id] !== undefined ? editing[id] : (items.find(i => i.id === id)?.message || '')
    await axios.put(`/api/messages/${id}`, { message: newMessage, status: 1 })
    setItems(items.filter((item) => item.id !== id))
  }

  const handleDelete = async (id) => {
    await axios.delete(`/api/messages/${id}`)
    setItems(items.filter((item) => item.id !== id))
  }

  useEffect(() => {
    const load = async () => {
      setError('')
      setLoading(true)
      try {
        const { data } = await axios.get('/api/messages/pending')
        setItems(data)
      } catch (e) {
        setError("Impossible de charger les messages")
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  return (
    <div className="mx-auto max-w-7xl py-8">
      <h1 className="text-2xl font-bold mb-6">Messages à valider</h1>

      {error && (
        <div className="mb-4 rounded-md bg-red-50 p-3 text-sm text-red-700">{error}</div>
      )}
      {success && (
        <div className="mb-4 rounded-md bg-green-50 p-3 text-sm text-green-700">{success}</div>
      )}

      {loading ? (
        <div>Chargement...</div>
      ) : (
        <div className="overflow-x-auto rounded-md border border-gray-200">
          <table className="min-w-full table-fixed divide-y divide-gray-200">
            <thead className="bg-gray-50 hidden md:table-header-group">
              <tr>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-[20%]">Message original</th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-[35%]">Message</th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-[25%]">Infos</th>
                <th className="px-3 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-[20%]">Action</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 bg-white text-xs">
              {items.map((row) => (
                <tr key={row.id} className="hover:bg-gray-50 block md:table-row bg-white even:bg-green-100">
                  <td className="px-3 py-2 text-gray-700 max-w-xs whitespace-pre-wrap block md:table-cell" title={row.message_origine}>{row.message_origine}</td>
                  <td className="px-3 py-2 text-gray-700 block md:table-cell overflow-hidden" title={editing[row.id] ?? row.message}>
                    <textarea
                      rows={15}
                      className="w-full max-w-full min-w-0 box-border bg-gray-100 p-2 rounded-md whitespace-pre-wrap resize-y"
                      style={{ width: '100%' }}
                      value={editing[row.id] !== undefined ? editing[row.id] : (row.message || '')}
                      onChange={(e) => setEditing(prev => ({ ...prev, [row.id]: e.target.value }))}
                    />
                  </td>
                  <td className="px-3 py-2 text-gray-700 block md:table-cell">rédigé le {new Date(row.created_at).toLocaleString()}<br />{row.bien_name}<br />{row.fullname}<br />{row.email}<br />{row.phonenumber}<br />{row.marketplace}<br />{row.journey}<br />{row.pax} adultes<br /><br/> Infos complémentaires : <br />{row.reason}</td>
                  <td className="px-3 py-2 text-gray-700 block md:table-cell">
                    <button className="hover:bg-indigo-700 bg-indigo-600 text-white px-4 py-2 rounded-md" onClick={() => handleValidate(row.id)}>Sauvegarder</button><br /><br />
                    <button className="hover:bg-green-700 bg-green-600 text-white px-4 py-2 rounded-md" onClick={() => handleSend(row.id)}>Envoyer</button><br /><br />
                    <button className="hover:bg-red-700 bg-red-600 text-white px-4 py-2 rounded-md" onClick={() => handleDelete(row.id)}>Supprimer</button><br /><br />
                    <button className="hover:bg-yellow-700 bg-yellow-600 text-white px-4 py-2 rounded-md" onClick={() => handleDeepL(row)}>DeepL</button><br /><br />
                    <button className="hover:bg-purple-700 bg-purple-600 text-white px-4 py-2 rounded-md" onClick={() => handleYaago(row)}>Yaago</button></td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr>
                  <td colSpan="4" className="px-3 py-6 text-center text-sm text-gray-500">Aucun message en attente</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}


